export default "__VITE_ASSET__Dl0LdK3N__"